import React, { FC } from 'react'
import { Navigate } from 'react-router-dom'
import { isEmpty, isNil } from 'lodash'

import CONFIG from '../config'
import { COOKIE_TFF } from '../constants/auth-constants'
import { ServiceSend } from '../types/interface/fsm.interface'
import { SessionData, SessionDataNoBID } from '../types/interface/session.interface'
import { FSMRouterConsumer } from '../FSM'
import { getSessionStorageAuthData } from '../service/util.service'
import getCookieByName from '../util/getCookieByName'

export interface FSMProtectedRouteProps {
  component: React.ComponentType<{ send: ServiceSend }>
}

// react-router v7's <Routes> accepts only <Route> children, so this is no longer a <Route> — it is
// the guard element a <Route> renders. Path matching lives on the <Route path> in `App.tsx`.
const FSMProtectedRoute: FC<FSMProtectedRouteProps> = ({ component: Component }) => {
  const isTFF = getCookieByName(COOKIE_TFF).includes('true')
  const parsedUserInfo: SessionData = getSessionStorageAuthData(CONFIG.USER_INFO_KEY)
  const parsedUserInfoBID: SessionData = getSessionStorageAuthData(CONFIG.USER_INFO_KEY_BID)

  const isAuthenticated: boolean = !!parsedUserInfo && !!(parsedUserInfo as SessionDataNoBID).token
  const isAuthenticatedBID: boolean = !isEmpty(parsedUserInfoBID) && !isNil(parsedUserInfoBID.token)

  const isAuthorized = isAuthenticated || isTFF || isAuthenticatedBID

  return (
    <FSMRouterConsumer>
      {(context) => {
        const send = context.service?.send

        if (isAuthorized && send) {
          return <Component send={send} />
        }

        //FIXME: Redirected us back to /auth every time: getRedirectPath(protectSrc)
        //FIXME: Better to return null
        // `replace` keeps v5 <Redirect>'s semantics — it replaced the entry, so browser back cannot
        // walk straight back into the guard. v7's <Navigate> pushes unless told otherwise.
        return <Navigate to='/' replace />
      }}
    </FSMRouterConsumer>
  )
}

export default FSMProtectedRoute
